<template>
  <img 
    :src="pawSrc" 
    class="paw" 
    alt="" 
  />
</template>

<script>
import paw from '@/assets/paw.svg'

export default {
  name: 'Paw',
  data () {
    return {
      pawSrc: paw
    }
  }
}
</script>

<style scoped>
.paw {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  padding: 1.5rem 4rem 10rem;
  pointer-events: none;
  z-index: 20;
  mix-blend-mode: difference;
}

@media (max-width: 1000px) {
  .paw { padding-bottom: 1.5rem; }
}
</style>

<style>
.safari .paw { 
  height: 88.5vh; 
}
</style>